/* eslint-disable space-before-function-paren */
import Sandbox from '@/components/GeneralViews/Sandbox.vue'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
// TODO - Need only for metainf...
import BasicLayout from '@/components/Dashboard/Layout/BasicLayout.vue'

import ObjectLayout from '@/components/Dashboard/Layout/ObjectLayout.vue'
import ObjectView from '@/components/UIComponents/ObjectView'
import ObjectCreate from '@/components/UIComponents/ObjectCreate'

// Library
import Library from '@/components/Dashboard/Views/Library/Library.vue'

// Projects
import Projects from '@/components/Dashboard/Views/Projects/Projects.vue'
import Project from '@/components/Dashboard/Views/Projects/Project.vue'
import ProjectCreateUpdate from '@/components/Dashboard/Views/Projects/ProjectCreateUpdate.vue'

// Dashboard
import Dashboards from '@/components/Dashboard/Views/Projects/Dashboards/Dashboards.vue'
import Dashboard from '@/components/Dashboard/Views/Projects/Dashboards/Dashboard.vue'

// Triggers
import Triggers from '@/components/Dashboard/Views/Projects/Dashboards/Dashboards.vue'
import Trigger from '@/components/Dashboard/Views/Projects/Dashboards/Dashboard.vue'
import TriggerCreateUpdate from '@/components/Dashboard/Views/Trigger/TriggerNew.vue'

// Apis
import ApiCreateUpdate from '@/components/Dashboard/Views/Apis/ApiCreateUpdate.vue'
import Api from '@/components/Dashboard/Views/Apis/Api.vue'
import Apis from '@/components/Dashboard/Views/Apis/Apis.vue'

// Functions
import Function from '@/components/Dashboard/Views/Functions/Function.vue'
import Functions from '@/components/Dashboard/Views/Functions/Functions.vue'
import FunctionCreateUpdate from '@/components/Dashboard/Views/Functions/FunctionCreateUpdate.vue'

// Queries
import QueryCreateUpdate from '@/components/Dashboard/Views/Projects/Dashboards/QueryBuilder.vue'
import Queries from '@/components/Dashboard/Views/Projects/Queries/Queries.vue'

// GeneralViews
import Signin from '@/components/Dashboard/Views/Pages/Signin.vue'
import Signup from '@/components/Dashboard/Views/Pages/Signup.vue'
import SignupActivation from '@/components/Dashboard/Views/Pages/SignupActivation.vue'
import SignupEmailValidation from '@/components/Dashboard/Views/Pages/SignupEmailValidation.vue'
import Support from '@/components/Dashboard/Views/Pages/Support.vue'
import ResetPassword from '@/components/Dashboard/Views/Pages/ResetPassword.vue'

// Integration
import Integrations from '@/components/Dashboard/Views/Integrations/Integrations.vue'
import IntegrationCreateUpdate from '@/components/Dashboard/Views/Integrations/IntegrationCreateUpdate'

// Redirect pages
import NotFound from '@/components/GeneralViews/NotFoundPage.vue'
import Unauthorized from '@/components/GeneralViews/UnauthorizedPage.vue'

// Settings
import SettingsProfile from '@/components/Dashboard/Views/Settings/Profile.vue'
import SettingsCompany from '@/components/Dashboard/Views/Settings/Company.vue'
import SettingsMembers from '@/components/Dashboard/Views/Settings/Members.vue'
import SettingsInvite from '@/components/Dashboard/Views/Settings/Invite.vue'

// Audit management
import SettingsAudit from '@/components/Dashboard/Views/Settings/Audit.vue'

// Datastore Management
import Datasets from '@/components/Dashboard/Views/Datastore/Datasets.vue'
import Dataset from '@/components/Dashboard/Views/Datastore/Dataset.vue'
import DatasetCreateUpdate from '@/components/Dashboard/Views/Datastore/DatasetCreateUpdate.temp.vue'

import { requireAuth } from '@/utils/auth'

const libraryPage = {
    path: '/library',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Library',
            menu: 'home',
            component: Library,
        },
        {
            path: 'integrations',
            name: 'Global integrations',
            component: Integrations,
        },
    ],
}

const ProjectObjectViewPage = {
    path: '/projects/:project/view',
    component: ObjectLayout,
    beforeEnter: requireAuth,
    children: [{
        path: ':object/:identifier',
        name: 'view-object',
        component: ObjectView,
    }],
}
const ProjectObjectCreatePage = {
    path: '/projects/:project/create',
    component: ObjectLayout,
    beforeEnter: requireAuth,
    children: [{
        path: ':object',
        name: 'create-object',
        component: ObjectCreate,
    }],
}
const LibraryObjectViewPage = {
    path: '/library/view',
    component: ObjectLayout,
    beforeEnter: requireAuth,
    children: [{
        path: ':object/:identifier',
        name: 'view-object-library',
        component: ObjectView,
    }],
}
const LibraryObjectCreatePage = {
    path: '/library/create',
    component: ObjectLayout,
    beforeEnter: requireAuth,
    children: [{
        path: ':object',
        name: 'create-object-library',
        component: ObjectCreate,
    }],
}

const projectsPage = {
    path: '/projects',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Projects',
            meta: { menu: '++++' },
            component: Projects,
        },
        {
            path: 'new',
            name: 'New Project',
            component: ProjectCreateUpdate,
        },
        {
            path: ':project',
            name: 'Project',
            meta: { menu: '-----' },
            component: Project,
        },
    ],
}

const projectTriggers = {
    path: '/projects/:project/triggers',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Triggers',
            component: Triggers,
        },
        {
            path: ':trigger',
            name: 'Trigger',
            component: Trigger,
        },
    ],
}
const projectDashboards = {
    path: '/projects/:project/dashboards',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Dashboards',
            component: Dashboards,
        },
        {
            path: ':dashboard',
            name: 'Dashboard',
            component: Dashboard,
        },
    ],
}

const projectDatasets = {
    path: '/projects/:project/datasets',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Datasets',
            component: Datasets,
        },
        {
            path: ':dataset',
            name: 'Dataset',
            component: Dataset,
        },
    ],
}

const projectQueries = {
    path: '/projects/:project/queries',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Queries',
            component: Queries,
        },
        {
            path: ':query',
            name: 'Query',
            component: QueryCreateUpdate,
        },
    ],
}
const projectFunctions = {
    path: '/projects/:project/functions',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Functions',
            component: Functions,
        },
        {
            path: ':function',
            name: 'Function',
            component: Function,
        },
    ],
}
const projectApis = {
    path: '/projects/:project/apis',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: '',
            name: 'Apis',
            component: Apis,
        },
        {
            path: ':api',
            name: 'Api',
            component: Api,
        },
    ],
}

const projectCreateObjects = {
    path: '/projects/:project/create',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
            path: 'dataset',
            name: 'CreateDataset',
            component: DatasetCreateUpdate,
        },
        {
            path: 'query',
            name: 'CreateQuery',
            component: QueryCreateUpdate,
        },
        {
            path: 'api',
            name: 'CreateApi',
            component: ApiCreateUpdate,
        },
        {
            path: 'function',
            name: 'CreateFunction',
            component: FunctionCreateUpdate,
        },
        {
            path: 'trigger',
            name: 'CreationTrigger',
            component: TriggerCreateUpdate,
        },
        {
            path: 'integration',
            name: 'CreationIntegration',
            component: IntegrationCreateUpdate,
        },
    ],
}

const projectIntegrations = {
    path: '/projects/:project/integrations',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [{
        path: '',
        name: 'Integrations',
        component: Integrations,
        props: true,
    }],
}

const settingsMenu = {
    path: '/settings',
    component: DashboardLayout,
    redirect: '/settings/account',
    beforeEnter: requireAuth,
    children: [{
            path: 'account',
            name: 'Account',
            component: SettingsProfile,
        },
        {
            path: 'company',
            name: 'Company',
            component: SettingsCompany,
        },
        {
            path: 'members',
            name: 'Members',
            component: SettingsMembers,
        },
        {
            path: 'invite',
            name: 'Invite',
            component: SettingsInvite,
        },
        {
            path: 'audit',
            name: 'Audit',
            component: SettingsAudit,
        },
    ],
}

const signinPage = {
    path: '/signin',
    name: 'Sign in',
    component: Signin,
}

const signupActivationPage = {
    path: '/signup/activation',
    name: 'Sign up activation',
    component: SignupActivation,
}

const signupEmailValidationPage = {
    path: '/signup/email/validation/:key',
    name: 'Email Validation',
    component: SignupEmailValidation,
}

const signupPage = {
    path: '/signup/',
    name: 'Sign up',
    component: Signup,
    children: [{
        path: 'invite/:key?',
        name: 'Sign up with invite',
        component: Signup,
    }],
}

const signoutPage = {
    path: '/logout',
    name: 'Sign out',
    beforeEnter(to, from, next) {
        requireAuth.logout()
        next('/')
    },
}

const resetPassword = {
    path: '/account/password-reset/confirm/:uid/:key',
    name: 'ResetPassword',
    component: ResetPassword,
}

const supportPage = {
    path: '/support',
    name: 'Support',
    component: Support,
}

const unauthorizedPage = {
    path: '/unauthorized',
    component: Unauthorized,
}

const routes = [
    {
        path: '/sandbox',
        component: Sandbox,
        beforeEnter: requireAuth,
    },
     {
        path: '/',
        component: DashboardLayout,
        beforeEnter: requireAuth,
        redirect: '/projects',
    },
    LibraryObjectCreatePage,
    LibraryObjectViewPage,
    ProjectObjectCreatePage,
    ProjectObjectViewPage,
    projectCreateObjects,
    libraryPage,
    projectsPage,
    projectIntegrations,
    signinPage,
    signupPage,
    signoutPage,
    signupActivationPage,
    signupEmailValidationPage,
    supportPage,
    resetPassword,
    projectApis,
    // datastoreMenu,
    // apisMenu,
    // integrationsMenu,
    // triggersMenu,
    // functionsMenu,
    settingsMenu,
    unauthorizedPage,
    { path: '*', component: NotFound },
]
export default routes
